$(document).ready(function() {
    $('input[name=confirm_before_work]').on('change', function() {
        if (!$(this).is(':checked')) {
            $('#confirm_before_work_btn').addClass('disabled')
        } else {
            $('#confirm_before_work_btn').removeClass('disabled')
        }
    })

    $('input[name=confirm_content_before_work]').on('change', function() {
        if (!$(this).is(':checked')) {
            $('#confirm_content_before_work_btn').addClass('disabled')
        } else {
            $('#confirm_content_before_work_btn').removeClass('disabled')
        }
    })

    $('#confirm_ok').on('click', function() {
        $('#plan_confirm').addClass('d-none')
        $('#plan_confirmed').removeClass('d-none')
        $('#output_estimation').addClass('disabled')
    })
});

$(document).on('click', 'input[type=checkbox]', function(event) {
    if($(this).is(':checked')){
        $(this).attr('checked', 'checked');
    } else {
        $(this).removeAttr('checked');
    }
});

$(document).on('keypress', '.next-input', function(event) {
    if (event.which === 13) {
        event.preventDefault();
        $(this).next('input').focus();
    }
});

$(document).on('click','td', function(e){
    $(this).find('input[type=radio]').prop('checked', true);
    let cb = $(e.target).children(":checkbox");
    cb.attr("checked", !cb.attr("checked"));
});